import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {RevenueDistributionStore} from "./store/revenue-distribution-store";
import {ActiveElement, ChartEvent} from "chart.js";
import {Chart} from "chart.js/auto";
import {PlatformScannerService} from "../../../../../../_services/platform-scanner.service";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {Platform} from "../../../../../../enums/platform";
import {Subscription} from "rxjs";
import {ErrorMessageComponent} from "../../../../common/components/error-message/error-message.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'app-distribution-chart',
  templateUrl: './distribution-chart.component.html',
  styleUrls: ['./distribution-chart.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ErrorMessageComponent
  ],
  providers: [RevenueDistributionStore]
})
export class DistributionChartComponent implements OnDestroy {
  chart: Chart<"doughnut"> | undefined;
  protected readonly ErrorCodes = ErrorCodes;
  private subscription: Subscription = new Subscription();
  private chartElement!: ElementRef<HTMLCanvasElement>;

  constructor(
    public platformScannerService: PlatformScannerService,
    public revenueDistributionStore: RevenueDistributionStore
  ) {
    this.subscribeToStore()
  }

  @ViewChild('pieChart', {static: false}) set contentPie(content: ElementRef<HTMLCanvasElement>) {
    if (content) {
      this.chartElement = content;
      //this.createChart();
    }
  }

  static stringToCurrency(value: string): string {
    return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(Number(value))
  }

  subscribeToStore() {
    this.subscription.add(
      this.revenueDistributionStore.updateNotifier.subscribe(() => {
        setTimeout(() => {
          this.createChart()
        }, 0)
      })
    )
  }

  createChart() {

    if (this.chart != undefined) {
      this.chart.destroy()
    }

    if (this.chartElement === undefined) {
      return;
    }
    if (this.revenueDistributionStore.dataset === undefined) return;

    if (this.revenueDistributionStore.dataset.datasets![0].data.length === 0) return;

    let selectedDatasetIndex: number | undefined = undefined;
    let selectedIndex: number | undefined = undefined;
    let selectedElement: ActiveElement | undefined = undefined;
    let platform = this.platformScannerService.getPlatform();

    this.chart = new Chart<"doughnut" | any | any>(this.chartElement.nativeElement, {
        type: 'doughnut',
        data: this.revenueDistributionStore.dataset,
        options: {
          maintainAspectRatio: true,
          responsive: true,
          aspectRatio: 0,
          cutout: '75%',
          hover: {intersect: true},
          // @ts-ignore
          hoverOffset: 22,
          layout: {
            padding: {
              bottom: 25,
              top: 30
            }
          },

          onClick: (evt: any, item: any) => {
            if (item.length === 0) {
              selectedDatasetIndex = undefined;
              selectedIndex = undefined;
              selectedElement = undefined;
              return;
            }
            selectedIndex = item[0].index;
            selectedDatasetIndex = item[0].datasetIndex;
            selectedElement = item[0];
          },
          onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
            if (elements.length === 0) {
              chart.canvas.style.cursor = 'default';
              selectedDatasetIndex = undefined;
              selectedIndex = undefined;
              selectedElement = undefined;
              return;
            }
            //elements[0].element.options.backgroundColor = elements[0].element.options.$animations.backgroundColor._to

            chart.canvas.style.cursor = 'pointer';
            // display information in center
            selectedElement = elements[0];
            selectedIndex = elements[0].index;
            selectedDatasetIndex = elements[0].datasetIndex;

          },
          plugins: {
            tooltip: {
              enabled: false,
            },
          }
        },
        plugins: [{
          id: "centerText",
          beforeDraw: function (chart, a, b) {
            let height = chart.height
            let ctx = chart.ctx;
            // @ts-ignore
            let innerRadius = chart.getDatasetMeta(0).data[0].innerRadius

            let scaleForText = innerRadius - 10;
            ctx.save();
            let multiplier = 3.25;
            let fontSizeBig = ((scaleForText * multiplier) / 150).toFixed(2);
            let fontSizeMedium = ((scaleForText * multiplier) / 225).toFixed(2);
            let unit = "em";
            let font = "sans-serif";

            let textColor = "#181818";

            let pieChartCenterX = chart.getDatasetMeta(0).data[0].x
            let pieChartCenterY = chart.getDatasetMeta(0).data[0].y


            let text;

            let marginTopPercentageText = Number(fontSizeBig) * 20;
            let marginBottomTitleText = Number(fontSizeBig) * 20;

            let marginYRectangle = -1 * Number(fontSizeBig) * 12 - 5;


            ctx.font = fontSizeBig + unit + " " + font;
            ctx.fillStyle = textColor;
            ctx.textBaseline = "middle";
            ctx.textAlign = "center";

            // @ts-ignore
            let total = chart.data.datasets[0].data.reduce((sum: number, value: number) => sum + value, 0);


            // @ts-ignore
            for (let legendItem in chart.legend.legendItems) {
              // @ts-ignore
              if (chart.legend.legendItems[legendItem].hidden) {
                // @ts-ignore
                total -= chart.data.datasets[0].data[legendItem]
              }
            }

            if (selectedIndex === undefined || selectedDatasetIndex === undefined) {

              text = DistributionChartComponent.stringToCurrency(total!.toString() as string)

            } else {


              text = DistributionChartComponent.stringToCurrency(chart.data.datasets[selectedDatasetIndex!].data[selectedIndex!]!.toString())
            }


            let textWidth = ctx.measureText(text).width;
            if (textWidth > scaleForText * 2) {
              let newFontSize = (scaleForText * 2 / textWidth) * Number(fontSizeBig);
              fontSizeBig = newFontSize.toFixed(2);
            }
            ctx.font = fontSizeBig + unit + " " + font;


            ctx.fillText(text, pieChartCenterX, pieChartCenterY);

            ctx.save();

            ctx.font = fontSizeMedium + unit + " " + font;
            ctx.fillStyle = textColor;
            // @ts-ignore
            if (selectedIndex !== undefined && selectedDatasetIndex !== undefined && chart.data.datasets[selectedDatasetIndex].data[selectedIndex] <= Number(total)) {
              // @ts-ignore
              text = "~ " + (chart.data.datasets[selectedDatasetIndex].data[selectedIndex] / Number(total) * 100).toFixed(2) + "%"
            } else {
              text = "100%"
            }

            ctx.fillText(text, pieChartCenterX, pieChartCenterY + marginTopPercentageText);
            ctx.restore();


            ctx.font = fontSizeMedium + unit + " " + font;
            ctx.fillStyle = textColor;
            if (selectedIndex !== undefined && selectedDatasetIndex !== undefined) {
              // @ts-ignore
              text = chart.data.labels[selectedIndex]
            } else {
              text = "Summe"
            }
            // @ts-ignore
            ctx.fillText(text, pieChartCenterX, pieChartCenterY - marginBottomTitleText);

            ctx.restore();
            if (selectedIndex === undefined || selectedDatasetIndex === undefined) {
              return;
            }
            ctx.save();


            ctx.font = fontSizeMedium + unit + " " + font;
            // @ts-ignore
            let underscoreLength = chart.ctx.measureText(text).width;

            if (platform !== Platform.Mozilla && platform !== Platform.MozillaMobile) {
              ctx.roundRect(pieChartCenterX - underscoreLength / 2 - 5, pieChartCenterY + marginYRectangle, underscoreLength + 10, 7, [100])

            } else {
              ctx.rect(pieChartCenterX - underscoreLength / 2 - 5, pieChartCenterY + marginYRectangle, underscoreLength + 10, 7)
            }

            ctx.fillStyle = selectedElement?.element?.options?.backgroundColor;
            ctx.fill()
            ctx.restore();
          }
        },
          {
            id: 'customCanvasBackgroundColor',
            beforeDraw: (chart, args, options) => {
              if (options.color === undefined) {
                return;
              }
              const {ctx} = chart;
              ctx.save();
              ctx.globalCompositeOperation = 'destination-over';
              ctx.fillStyle = options.color || '#99ffff';
              ctx.fillRect(0, 0, chart.width, chart.height);
              ctx.restore();
            }
          }
        ]

      }
    );

  }

  ngOnDestroy() {
    if (this.chart != undefined) {
      this.chart.destroy()
    }
    this.subscription.unsubscribe()
  }
}
